import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./MemberCRUD";
import { memberSlice } from "./MemberSlice";

const { actions } = memberSlice;

export const callMemberList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberListsFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkMemberList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const updateMemberStatus = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.updateMemberFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: updateMemberList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const memberTelegramUnbind = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .memberTelegramUnbind(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberTelegramUnbindFetch());
          return response;
        }
      } else {
        throw new Error("Error api: memberTelegramUnbind");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const removeMemberPromotion =
  (queryParams, isFastLink) => (dispatch) => {
    dispatch(actions.startCall({ callType: ReduxCallTypesConst.OVERLAY }));

    return requestToApi
      .removeMemberPromotion(queryParams, isFastLink)
      .then((response) => {
        if (response) {
          if (!response.data.isAbort) {
            dispatch(actions.memberPromotionRemoved());
            return response;
          }
        } else {
          throw new Error("Error api: removeMemberPromotion");
        }
      })
      .catch((error) => {
        dispatch(
          actions.catchError({ error, callType: ReduxCallTypesConst.OVERLAY })
        );
        throw error;
      });
  };
export const createMemberList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.addMemberFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: addMemberList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const editMemberList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.editMemberFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: editMemberList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callMemberGameList = (queryParams, isFastlink) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberGameList(queryParams, isFastlink)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberGameListsFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: callMemberGameLists");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callMemberGameListBalance =
  (queryParams, isFastLink) => (dispatch) => {
    dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

    return requestToApi
      .checkMemberGameList(queryParams, isFastLink)
      .then((response) => {
        if (response) {
          if (!response.data.isAbort) {
            dispatch(
              actions.memberGameListsBalanceFetch({ data: response.data })
            );
            return response;
          }
        } else {
          throw new Error("Error api: callMemberGameListsBalance");
        }
      })
      .catch((error) => {
        dispatch(
          actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
        );
        throw error;
      });
  };
export const clearMemberGameBalance = () => (dispatch) => {
  dispatch(actions.clearMemberGameBalance());
};
export const fetchMemberGameBalance =
  (queryParams, isFastLink) => (dispatch) => {
    dispatch(actions.startCall({ callType: ReduxCallTypesConst.DETAIL }));

    return requestToApi
      .checkMemberGameList(queryParams, isFastLink)
      .then((response) => {
        if (response) {
          if (!response.data.isAbort) {
            dispatch(actions.memberGameBalanceFetch({ data: response.data }));
            return response;
          }
        } else {
          throw new Error("Error api: callMemberGameListsBalance");
        }
      })
      .catch((error) => {
        dispatch(
          actions.catchError({ error, callType: ReduxCallTypesConst.DETAIL })
        );
        throw error;
      });
  };
export const memberTransfer = (queryParams, isFastLink) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberGameList(queryParams, isFastLink)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberTransferFetch({ data: { ...response.data, companycode: queryParams.companycode } }));
          return response;
        }
      } else {
        throw new Error("Error api: memberTransfer");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const createGameId = (queryParams, isFastLink) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberGameList(queryParams, isFastLink)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.addGameIdFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: createGameId");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callMemberReportList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberReportList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberReportListsFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkMemberReportList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callMemberGatewayList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberrTelcoNGatewayList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberGatewayListsFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkMemberrTelcoNGatewayList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callMemberTelcoList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkMemberrTelcoNGatewayList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberTelcoListsFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkMemberrTelcoNGatewayList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const changeMemberAppPassword =
  (queryParams, isFastLink) => (dispatch) => {
    dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

    return requestToApi
      .changeMemberPassword(queryParams, isFastLink)
      .then((response) => {
        if (response) {
          if (!response.data.isAbort) {
            dispatch(
              actions.changeMemberAppPasswordFetch({ data: response.data })
            );
            return response;
          }
        } else {
          throw new Error("Error api: changeMemberPassword");
        }
      })
      .catch((error) => {
        dispatch(
          actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
        );
        throw error;
      });
  };
export const callMemberGameLogReport = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .memberGameLogReport(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberGameLogReportFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberGameLogReportFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callVBossReport = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .vBossReport(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vBossReportFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: vBossReportFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
